import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getProductosActivosTrazabilidad`, method: 'GET', body: null, token: token})
}
